module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "events"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.$t('categories.events'),
      "level": 2,
      "font": "astonished",
      "color": "red"
    }
  }), _vm._v(" "), _c('nav', [_c('router-link', {
    staticClass: "item",
    class: {
      selected: _vm.gigsSelected
    },
    attrs: {
      "to": {
        name: 'gigs'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "calendar",
      "scale": "1.3"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('events.gigs')))])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    class: {
      selected: _vm.reportsSelected
    },
    attrs: {
      "to": {
        name: 'liveReports'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "bullhorn",
      "scale": "1.3"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('events.liveReports')))])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    class: {
      selected: _vm.galleriesSelected
    },
    attrs: {
      "to": {
        name: 'photoGalleries'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "photo",
      "scale": "1.3"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('events.photos')))])], 1)], 1), _vm._v(" "), _c('router-view', {
    on: {
      "gigs": _vm.onGigs,
      "reports": _vm.onReports,
      "galleries": _vm.onGalleries
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b10e634"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/Events.vue
// module id = 245
// module chunks = 0